"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var ExternalLinkSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M13,10 L14,10 L14,13 C14,13.5522847 13.5522847,14 13,14 L5,14 C4.44771525,14 4,13.5522847 4,13 L4,5 C4,4.44771525 4.44771525,4 5,4 L8,4 L8,5 L5,5 L5,13 L13,13 L13,10 Z M12.2945109,5 L10,5 L10,4 L14,4 L14,8 L13,8 L13,5.70507349 L9.85011655,8.86555983 C9.65767608,9.05864808 9.3451433,9.05917321 9.15205505,8.86673273 C8.95875875,8.67399556 8.95795484,8.36129376 9.15017694,8.1676465 L12.2945109,5 Z" })));
};
ExternalLinkSmall.displayName = 'ExternalLinkSmall';
exports.default = ExternalLinkSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ExternalLinkSmall.js.map